import type {DeletionIdentity} from './account-deletion.types';

export const ACCOUNT_DELETION_REQUEST_PATH = '/auth/account-deletion-requests';
export const ACCOUNT_DELETION_CONFIRM_PATH = `${ACCOUNT_DELETION_REQUEST_PATH}/confirm`;
export const DEFAULT_CODE_EXPIRY_SECONDS = 300;
export const DEFAULT_RETRY_SECONDS = 60;
export const ACCOUNT_DELETION_CODE_LENGTH = 6;
export const ACCOUNT_DELETION_NEUTRAL_MESSAGE =
  'If your details match our records, we’ve sent a code.';

export const EMPTY_DELETION_IDENTITY: DeletionIdentity = {
  name: '',
  email: '',
  phone: '',
  channel: 'email'
};

export const deletionChannels = [
  {value: 'email', label: 'Email'},
  {value: 'sms', label: 'Phone (SMS)'}
] as const;
